import React, { memo, useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { Button as LinkButton } from 'antd';

// import '@style/modules/project/integrationNavigator.scss';
import '../../styles/modules/project/integrationNavigator.scss';
import { PowerBI } from './powerbiEmbed';
// import { UserguidModal } from './userguid';
// import { queryURLParams } from '@utils';

import { API } from '@service';
import actions from '@flux/action';
import SpnId from '@components/SpnID/SpnId';
import { FixedRatios, /*projectRole,*/ USER_ROLE_MODEL } from '@model';
import { addHTTP } from '@utils/common';
import useProjectId from '@hooks/useProjectId';
// import { Select } from 'antd';
import useCustomizedModuleData from '@hooks/useCustomizedModuleData';
import { filterXSS } from 'xss';

//https://app.powerbi.com/groups/63b73765-ad12-4ab0-a0c8-f72a1df1f867/reports/09af5ce1-1177-4c08-8bfe-0aa88623b84e/ReportSection
// 63b73765-ad12-4ab0-a0c8-f72a1df1f867
//09af5ce1-1177-4c08-8bfe-0aa88623b84e
const IntegrationHubViewMode = (props) => {
  const projectId = useProjectId();

  const { history, extraButton = null, ...rest } = props;
  const dispatch = useDispatch();
  const url = decodeURIComponent(history.location?.search);
  const params = new URLSearchParams(url);
  // const moduleId = params.get('moduleId');
  // const moduleName = params.get('moduleName');
  // const spnId =
  //   params.get('spnId') === 'null' || !params.get('spnId')
  //     ? null
  //     : params.get('spnId');
  // const projectModule = params.get('projectModule');

  const type =
    params.get('type') === 'null' || !params.get('type')
      ? null
      : params.get('type');
  const from =
    params.get('from') === 'null' || !params.get('from')
      ? 'modules'
      : params.get('from');
  const moduleValue = params.get('moduleValue');
  const integrationModuleId = params.get('integrationModuleId');
  const {
    targetModuleData: { link, moduleName, ratio, spnId },
    integrationModuleData,
  } = useCustomizedModuleData(moduleValue, integrationModuleId);
  // const userName = useSelector((state) => state.login.userInfo.name);

  const [isLoading, toggleLoading] = useState(true);
  // const [ratioLoading, toggleRatioLoading] = useState(false);
  const [error, toggleError] = useState(false);
  const [showInFullScreen, setShowInFullScreen] = useState(false);
  const FullScreenElemId = 'iframe-pdf-container';
  const [powerbiData, setPowerbiData] = useState('');
  const [sizeRatio, _setSizeRatio] = useState();
  const [refeshToken, setRefeshToken] = useState(null);

  const pbiDataRef = useRef(refeshToken);
  const timerRef = useRef();
  // const [integrationData, setIntegrationData] = useState();
  // const [ratioBtn, toggleRatioBtn] = useState(false);
  const projectPermission = useSelector(
    (state) => state.common.projectCompanyInfo?.currentUserPermission,
  );
  const isClient = useSelector(
    ({ login }) => login.userInfo.role === USER_ROLE_MODEL.CLIENT,
  );

  const setSizeRatio = (newRatio) =>
    _setSizeRatio(
      {
        [FixedRatios.FULL]: '64:27',
        [FixedRatios.BANNER]: '32:7',
        [FixedRatios.STANDARD]: '16:9',
        [FixedRatios.AUTO]: 'AUTO',
      }[newRatio] || newRatio,
    );

  useEffect(
    () => () => {
      console.log(`clearTimer ${timerRef.current}`);
      clearInterval(timerRef.current);
    },
    [],
  );

  useEffect(() => {
    // toggleRatioBtn(
    //   projectPermission !== projectRole['View-Only'] &&
    //     !isClient &&
    //     from === 'tiles',
    // );
  }, [isClient, projectPermission]);

  useEffect(() => {
    if (link && (type === 'powerbi' || from === 'modules')) {
      const res = verifyUrl(link);
      setPowerbiData(null);
      pbiDataRef.current = null;
      if (res && projectId) {
        fetchData(
          link.includes('navContentPaneEnabled')
            ? `${link}&navContentPaneEnabled=false`
            : link,
        );
      }
    } else {
      toggleLoading(false);
    }
    fetchRatioData();
  }, [link, projectId, window.location.search]);

  useEffect(() => {
    setSizeRatio(ratio ? ratio : 'AUTO');
    // setIntegrationData(integrationModuleData);
  }, [integrationModuleData]);

  // useEffect(() => {
  //   if (history.location.pathname === '/powerBI') {
  //     dispatch(
  //       actions.addBreadCrumb([
  //         {
  //           breadcrumbName: moduleName,
  //           path: `/powerBI`,
  //         },
  //       ]),
  //     );
  //   } else {
  //     dispatch(
  //       actions.addBreadCrumb([
  //         {
  //           breadcrumbName: 'Project Home',
  //           path: `/project-detail/${projectId}`,
  //         },
  //
  //         {
  //           breadcrumbName: moduleName,
  //           path: `/powerBI`,
  //         },
  //       ]),
  //     );
  //   }
  // }, [moduleName]);

  const getIframeContainerElem = () =>
    document.getElementById(FullScreenElemId);

  const fullScreenHandler = () => {
    if (!document.fullscreenElement) {
      setShowInFullScreen(false);
    }
  };

  useEffect(() => {
    const iFContainerElem = getIframeContainerElem();
    if (!iFContainerElem) {
      return () => {};
    }
    addFullScreenEventListener(iFContainerElem);
    return () => removeFullScreenEventListener(iFContainerElem);
  }, []);

  const addFullScreenEventListener = (elem) => {
    elem?.addEventListener('fullscreenchange', fullScreenHandler);
  };
  const removeFullScreenEventListener = (elem) => {
    elem.removeEventListener('fullscreenchange', fullScreenHandler);
  };

  const iframeRequestExitFullScreen = () => {
    setShowInFullScreen(false);
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const runTimer = (link) => {
    console.log(`runTimer ${link}`);
    if (timerRef.current) {
      console.log(`clearInterval`);
      clearInterval(timerRef.current);
    }
    const timerID = setInterval(async () => {
      console.log(`timer run moduleId:${integrationModuleId}`);
      const result = await API.postIntegrationHubModule(
        {
          integrationHubModuleInfo: [
            { moduleId: integrationModuleId, link, spnId },
          ],
        },
        projectId,
      );

      if (Array.isArray(result) && result[0].reportInfo?.status === 200) {
        if (result[0].reportInfo.accessToken !== refeshToken) {
          console.log(result[0].reportInfo);
          console.log(refeshToken);
          // setPowerbiData(result[0].reportInfo);
          setRefeshToken(result[0].reportInfo.accessToken);
          pbiDataRef.current = result[0].reportInfo;
        }
      }
    }, 8 * 60 * 1000);

    console.log(timerID);
    timerRef.current = timerID;
  };

  const fetchData = async (_link) => {
    const result = await API.postIntegrationHubModule(
      {
        integrationHubModuleInfo: [
          { moduleId: integrationModuleId, link: _link, spnId },
        ],
      },
      projectId,
    );
    toggleLoading(false);

    if (Array.isArray(result) && result[0].reportInfo?.status === 200) {
      setPowerbiData(result[0].reportInfo);
      pbiDataRef.current = result[0].reportInfo;
      setRefeshToken(result[0].reportInfo.accessToken);
      runTimer(_link);
      return { status: 200, info: result[0].reportInfo };
    }
    toggleError(true);

    return { status: 418 };
  };

  const verifyUrl = (value) => {
    // // const u = `https://api.powerbi.com?${value}`;
    // const u = `https://app.powerbi.com/groups/50d4a1db-8a38-417c-9940-6d08379dc295/reports/a4bed50a-13c6-407c-9b52-aefa540a8500/ReportSection`;
    try {
      const url = new URL(value);
      const pathName = url.pathname.split('/') || [];
      const spaceId = pathName[2];
      const reportId = pathName[4];
      if (
        spaceId &&
        reportId &&
        pathName[1] === 'groups' &&
        pathName[3] === 'reports'
      ) {
        toggleError(false);
        return true;
      }
      toggleError(true);
    } catch {
      toggleError(true);
    }
  };
  const iframeRequestEnterFullScreen = () => {
    const elem = document.getElementById(FullScreenElemId);
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    }
  };

  // const handleUserGuid = () => {
  //   toggleModalVisible(true);
  // };
  const goBack = () => {
    // history.goBack();
    history.push(`/project-detail/${projectId}`, {
      preventRefresh: true,
      // restoreScroll: isFromProjectHome,
      integrationModuleId,
    });
  };

  const fetchRatioData = async () => {
    // toggleRatioLoading(true);
    if (from !== 'tiles') {
      //fetch when is a project module
      const res = await dispatch(actions.getProjectSetting(projectId));
      // setIntegrationData(res);
      for (const module in res.moduleInfo) {
        if (res.moduleInfo[module].module === moduleName) {
          if (res.moduleInfo[module].ratio) {
            setSizeRatio(res.moduleInfo[module].ratio);
          } else {
            setSizeRatio('AUTO');
          }
        }
      }
    }
    // toggleRatioLoading(false);
  };

  // const generateFormData = (value, res) => {
  //   if (from === 'tiles') {
  //     const data = {
  //       integrationNavigatorName: res.projectInfo.integrationNavigatorName,
  //       integrationModuleWithTabList: res.integrationModuleWithTabList,
  //     };
  //     for (const tab in data.integrationModuleWithTabList) {
  //       const tabData = data.integrationModuleWithTabList[tab];
  //       if (!tabData.tabId) tabData.tabId = tabData.moduleList?.[0]?.tabId;
  //       for (const module in tabData.moduleList) {
  //         if (tabData.moduleList[module].module === moduleName) {
  //           tabData.moduleList[module].ratio = value;
  //         }
  //       }
  //     }
  //     return data;
  //   } else {
  //     //data when is a project module
  //     const data = {
  //       clientSetting: res.clientInfo,
  //       moduleSetting: res.moduleInfo,
  //       projectSetting: res.projectInfo,
  //       teamSetting: res.teamInfo,
  //     };
  //     data.teamSetting.operatorName = userName;
  //     for (const module in data.moduleSetting) {
  //       if (data.moduleSetting[module].module === moduleName) {
  //         data.moduleSetting[module].ratio = value;
  //       }
  //     }
  //     return data;
  //   }
  // };

  // const handleRatioChange = async (value) => {
  //   toggleRatioLoading(true);
  //   toggleLoading(true);
  //   const formData = generateFormData(value, integrationData);
  //   if (from === 'tiles') {
  //     const result = await API.saveIntegrationRequest({
  //       formData,
  //       projectId,
  //     });
  //     if (result === 'SUCCESS') setSizeRatio(value);
  //   } else {
  //     //handle when is a project module
  //     const result = await dispatch(actions.saveProjectSettings(formData));
  //     //TODO: result works but has error
  //     // console.log(result);
  //     setSizeRatio(value);
  //   }
  //   toggleLoading(false);
  //   toggleRatioLoading(false);
  // };

  return (
    <div
      className="integration-navigator integration-hub integration-hub-view-mode"
      // style={hideFlag ? { display: 'none' } : {}}
    >
      <div
        className="integration-hub-head"
        style={{ marginBottom: '0.625rem' }}
      >
        <span className="dd-back-btn" onClick={goBack}>
          <span className="appkiticon icon-left-chevron-fill a-font-12" />
          Back
        </span>
        {!error && (
          <div className="integration-hub-head-right">
            {/* {ratioBtn && (
              <div>
                Report Ratio
                <Select
                  style={{
                    width: 150,
                    marginRight: 10,
                    marginLeft: 10,
                    background: '#2C2C2C',
                  }}
                  value={sizeRatio}
                  loading={ratioLoading}
                  options={[
                    { value: '16:9', label: 'Standard Size' },
                    { value: '32:7', label: 'Banner Size' },
                    { value: '64:27', label: 'Full Size' },
                  ]}
                  onSelect={handleRatioChange}
                />
              </div>
            )} */}
            {extraButton}
            <div
              className="full-screen-button-bg"
              onClick={() => {
                setShowInFullScreen(true);
                iframeRequestEnterFullScreen();
              }}
            >
              <span className="icon-expand-fill a-btn-icon appkiticon" />
            </div>
          </div>
        )}
      </div>
      <>
        {isLoading && type === 'powerbi' && (
          <div
            style={{
              height: '100%',
              width: '100%',
              backgroundColor: '#333333',
            }}
          />
        )}
        {error && (
          <div className="hub-error-view-mode">
            <div>
              The workspace is not authorized to be shown in M&A Gateway.Please
              grant permission and try again.
            </div>
            <div>
              For steps on how to grant permission, leverage the User Guide.
            </div>
            <SpnId classname="role-control" />
          </div>
        )}
      </>

      {link && !error && (
        <div
          id={FullScreenElemId}
          className={`${showInFullScreen ? 'full-screen' : 'ratio-mode'}`}
        >
          <div
            className="full-screen-button-bg exit-full-screen"
            onClick={iframeRequestExitFullScreen}
          >
            <span className="appkiticon icon-minimize-fill a-btn-icon" />
          </div>
          {!isLoading && (type === 'powerbi' || from === 'modules') && (
            <PowerBI
              data={powerbiData}
              {...rest}
              token={refeshToken ? refeshToken : powerbiData?.accessToken}
              wholeScreen={true}
              screenRatio={sizeRatio}
            />
          )}
          {!isLoading && type !== 'powerbi' && from === 'tiles' && (
            <iframe
              className={`other-content ${
                sizeRatio === '64:27'
                  ? 'full-frame'
                  : sizeRatio === '16:9'
                  ? 'standard-frame'
                  : sizeRatio === '32:7'
                  ? 'platter-frame'
                  : sizeRatio === 'AUTO'
                  ? 'auto-frame'
                  : ''
              }`}
              src={filterXSS(addHTTP(link, 'https://'))}
            />
          )}
        </div>
      )}
      {/*<UserguidModal*/}
      {/*  isModalVisible={isModalVisible}*/}
      {/*  toggleModalVisible={toggleModalVisible}*/}
      {/*/>*/}
    </div>
  );
};
export default memo(IntegrationHubViewMode);
